// @flow
import React, { Component } from "react"
import { connect } from "react-redux"
import { Field, reduxForm } from "redux-form"
import { Motion, spring, presets } from "react-motion"
import {
  Modal,
  Content,
  Body,
  Header,
  Footer,
  PrimaryHeading,
  SubHeading,
  FooterLink
} from "../UI/Modal"
import { push } from "react-router-redux"
import { InputField, Label, FormGroup } from "../UI/Form"
import { PrimaryButton } from "../UI/Buttons"

class Reset extends Component<any, any> {
  render() {
    const { handleSubmit } = this.props
    return (
      <Modal>
        <form onSubmit={handleSubmit}>
          <Motion
            key="body"
            defaultStyle={{ y: -100, a: 0 }}
            style={{
              y: spring(0, presets.wobbly),
              a: spring(1, presets.noWobble)
            }}
          >
            {is => (
              <Body
                style={{
                  transform: `translate(0, ${is.y}px`,
                  opacity: is.a
                }}
              >
                <Header>
                  <PrimaryHeading>Kiosk Admin</PrimaryHeading>
                  <SubHeading>Reset Your Password</SubHeading>
                </Header>
                <Content>
                  <FormGroup>
                    <Label htmlFor="password">New Password</Label>
                    <Field
                      name="password"
                      component={InputField}
                      type="password"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="confirmPassword">Confirm Password</Label>
                    <Field
                      name="confirmPassword"
                      component={InputField}
                      type="password"
                    />
                  </FormGroup>
                  <PrimaryButton block={true}>Update Password</PrimaryButton>
                </Content>
                <Footer>
                  <FooterLink to="/auth/login">
                    Nevermind, I don't want to do this.
                  </FooterLink>
                </Footer>
              </Body>
            )}
          </Motion>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: "reset"
})(connect(null, { push })(Reset))



// WEBPACK FOOTER //
// ./src/PublicArea/Reset.js